import axiosInstance from './axiosInstance';

// GET all classes
export const getClass = async () => {
  try {
    const response = await axiosInstance.get('/class');
    return response.data;
  } catch (error) {
    console.error("Error fetching classes:", error.response?.data || error);
    throw error;
  }
};

// GET a single class
export const getClassById = async (id) => {
  try {
    const response = await axiosInstance.get(`/class/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching class:", error.response?.data || error);
    throw error;
  }
};

export const getClassByName = async (name, excludeId) => {
  try {
    const response = await axiosInstance.get(
      `/class/by-className/${encodeURIComponent(name)}`,
      {        params: excludeId ? { excludeId } : {},
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error checking class name:', error.response?.data || error);
    throw error;
  }
};

// CREATE a new class
export const createClass = async (classData) => {
  try {
    const response = await axiosInstance.post('/class', classData);
    return response.data;
  } catch (error) {
    console.error("Error creating class:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing class
export const updateClass = async (id, classData) => {
  try {
    const response = await axiosInstance.put(`/class/${id}`, classData);
    return response.data;
  } catch (error) {
    console.error("Error updating class:", error.response?.data || error);
    throw error;
  }
};

// DELETE a class
export const deleteClass = async (id) => {
  try {
    const response = await axiosInstance.delete(`/class/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting class:", error.response?.data || error);
    throw error;
  }
};
